import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyListModule } from '@angular/material/legacy-list';
import { ProductModelViewerDialogComponent } from '../../components/product-model-viewer-dialog/product-model-viewer-dialog.component';
import { Countertop } from '../../models/cutting/countertop';
import { LegacyDialogsService } from '../../services/legacy-dialogs.service';
import { ApiLinks } from '../cutting-panel-list/csl.api-links';

@Component({
  selector: 'csl-countertop-list',
  templateUrl: 'countertop-list.component.html',
  standalone: true,
  imports: [
    MatLegacyListModule,
    NgFor,
    NgIf,
    MatIconModule,
    NgClass,
    MatLegacyButtonModule,
    ProductModelViewerDialogComponent,
  ],
})
export class CountertopListComponent {
  @Input() countertops: Countertop[];
  @Input() isDisabledItem: (item: Countertop) => boolean;
  @Input() mode: 'view' | 'edit' = 'edit';
  @Input() orderId: number;
  @Output() editItem: EventEmitter<Countertop> = new EventEmitter();
  @Output() deleteItem: EventEmitter<Countertop> = new EventEmitter();

  constructor(private dialogsService: LegacyDialogsService) {}

  disabled(item: Countertop): boolean {
    return this.isDisabledItem?.(item) ?? false;
  }

  openModelViewer(countertop: Countertop): void {
    this.dialogsService.open(ProductModelViewerDialogComponent, {
      disableClose: false,
      panelClass: 'product-model-viewer-dialog',
      width: '95vw',
      height: '95vh',
      data: {
        modelUrl: `${ApiLinks.orderCountertop}/${countertop.id}/model-3d?orderId=${this.orderId}`,
      },
    });
  }
}
